import { useEmployeeEnrollmentInfoQuery } from '@alice-financial/alice-sdk'
import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { useMutationNotifier } from '../../../notifications/useMutationNotifier'
import { useConnectedCardsQuery } from '../../employee/spending/queries/connectedCardsQuery_gen'
import {
  ReconnectOmnyMutation,
  ReconnectOmnyMutationVariables,
  useReconnectOmnyMutation,
} from './reconnectOMNYCard_gen'

const CONNECTION_QUERIES = [
  useConnectedCardsQuery.getKey(),
  useEmployeeEnrollmentInfoQuery.getKey(), // because card connections affect account_status
]

export type OMNYCredentials = {
  username: string
  password: string
}

type ReconnectOMNYMutationOptions = UseGqlMutationCallbacks<
  ReconnectOmnyMutation,
  ReconnectOmnyMutationVariables
>
export const useReconnectOMNY = (mutationOptions?: ReconnectOMNYMutationOptions) => {
  const options = useMutationOptionsWithInvalidation(
    useMutationNotifier({}, mutationOptions),
    CONNECTION_QUERIES
  )
  return useReconnectOmnyMutation(options)
}
